<template>
  <div class="is-marginless is-paddingless section">
    <div class="entete">
      <div v-if="checkPermissions(constantes.emplacementPermission.lecture)"
           class="tab is-marginless">
        <ul>
          <li v-if="tabs.includes(constantes.EMPLACEMENT)"
              :class="{'is-active': isActiveTab(constantes.EMPLACEMENT)}"
              @click="updateActiveTab(constantes.EMPLACEMENT)">
            {{ $t('emplacement.tab.emplacement') }}
            {{ isVisible(constantes.EMPLACEMENT) ?
              ' (' + getNumberOfEmplacementsSelected + ')' : ''
            }}
          </li>
          <li v-if="tabs.includes(constantes.DISPOSITIF)"
              :class="{'is-active': isActiveTab(constantes.DISPOSITIF)}"
              @click="updateActiveTab(constantes.DISPOSITIF)">
            {{ $t('emplacement.tab.dispositif') }}
            {{ isVisible(constantes.DISPOSITIF) ?
            ' (' + getNumberOfDispositifsSelected + ')' : ''
            }}
          </li>
          <li v-if="tabs.includes(constantes.MATERIEL)"
              :class="{'is-active': isActiveTab(constantes.MATERIEL)}"
              @click="updateActiveTab(constantes.MATERIEL)">
            {{ $t('emplacement.tab.materiel') }}
            {{ isVisible(constantes.MATERIEL) ?
            ' (' + getNumberOfMaterielsSelected + ')' : ''
            }}
          </li>
          <li v-if="tabs.includes(constantes.FACE)"
              :class="{'is-active': isActiveTab(constantes.FACE)}"
              @click="updateActiveTab(constantes.FACE)">
            {{ $t('emplacement.tab.face') }}
            {{ isVisible(constantes.FACE) ?
            ' (' + getNumberOfFacesSelected + ')' : ''
            }}
          </li>
        </ul>
      </div>
    </div>
    <store-recherche-provider
      key="patrimoineEmplacements"
      v-if="activeTab === constantes.EMPLACEMENT"
      :name="constantes.storeName.emplacement"
      :copy="emplacementStore"
      :copyChanges="changesEmplacementStore">
      <emplacement
        is-selectable
        :selection="selection"
        :type-patrimoine-selected="typePatrimoine"
        @addSelection="value => addSelection(constantes.EMPLACEMENT, value)"
        @removeSelection="value => removeSelection(constantes.EMPLACEMENT, value)">
      </emplacement>
    </store-recherche-provider>
    <store-recherche-provider
      key="patrimoineDispositifs"
      v-if="activeTab === constantes.DISPOSITIF"
      :name="constantes.storeName.dispositif"
      :copy="dispositifStore"
      :copyChanges="changesDispositifStore">
      <dispositif
        is-selectable
        :selection="selection"
        :type-patrimoine-selected="typePatrimoine"
        @addSelection="value => addSelection(constantes.DISPOSITIF, value)"
        @removeSelection="value => removeSelection(constantes.DISPOSITIF, value)">
      </dispositif>
    </store-recherche-provider>
    <store-recherche-provider
      key="patrimoineMateriels"
      v-if="activeTab === constantes.MATERIEL"
      :name="constantes.storeName.materiel"
      :copy="materielStore"
      :copyChanges="changesMaterielStore">
      <materiel
        is-selectable
        :selection="selection"
        :type-patrimoine-selected="typePatrimoine"
        @addSelection="value => addSelection(constantes.MATERIEL, value)"
        @removeSelection="value => removeSelection(constantes.MATERIEL, value)">
      </materiel>
    </store-recherche-provider>
    <store-recherche-provider
      key="patrimoineFaces"
      v-if="activeTab === constantes.FACE"
      :name="constantes.storeName.face"
      :copy="faceStore"
      :copyChanges="changesFaceStore">
      <face
        is-selectable
        :selection="selection.faces"
        @addSelection="value => addSelection(constantes.FACE, value)"
        @removeSelection="value => removeSelection(constantes.FACE, value)">
      </face>
    </store-recherche-provider>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import emplacementStore, { initialState as initialStateEmplacement } from '@/store/modules/gabed/emplacement';
import dispositifStore, { initialState as initialStateDispositif } from '@/store/modules/gabed/dispositif';
import materielStore, { initialState as initialStateMateriel } from '@/store/modules/gabed/materiel';
import faceStore, { initialState as initialStateFace } from '@/store/modules/gabed/face';
import { EMPLACEMENT as emplacementPermission } from '@/configuration/gabed/permissionsGabedConf';
import {
  EMPLACEMENT,
  DISPOSITIF,
  MATERIEL,
  FACE,
} from '@/configuration/gabed/emplacement/emplacementConf';
import {
  EPHEMERAL_EMPLACEMENT_STORE,
  EPHEMERAL_DISPOSITIF_STORE,
  EPHEMERAL_MATERIEL_STORE,
  EPHEMERAL_FACE_STORE,
} from '@/configuration/gabed/patrimoine/patrimoineConf';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import emplacement from '@/components/gabed/emplacement/l_emplacement';
import dispositif from '@/components/gabed/dispositif/l_dispositif';
import materiel from '@/components/gabed/materiel/l_materiel';
import face from '@/components/gabed/face/l_face';
import { getAll as getAllDispositifs } from '@/api/gabed/dispositif';
import { getAll as getAllMateriels } from '@/api/gabed/materiel';
import { getAll as getAllFaces } from '@/api/gabed/face';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { changesPatrimoineStore } from '@/services/gabed/patrimoine/patrimoineSelection';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'l_patrimoine',
  props: {
    typePatrimoine: {
      type: String,
      required: true,
      default: FACE,
    },
    patrimoineAssociated: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: null,
      constantes: {
        storeName: {
          emplacement: EPHEMERAL_EMPLACEMENT_STORE,
          dispositif: EPHEMERAL_DISPOSITIF_STORE,
          materiel: EPHEMERAL_MATERIEL_STORE,
          face: EPHEMERAL_FACE_STORE,
        },
        NO_PAGINATION,
        emplacementPermission,
        EMPLACEMENT,
        DISPOSITIF,
        MATERIEL,
        FACE,
      },
      emplacementStore,
      dispositifStore,
      materielStore,
      faceStore,
      selection: {
        emplacements: [],
        dispositifs: [],
        materiels: [],
        faces: [],
      },
      changesEmplacementStore: changesPatrimoineStore(initialStateEmplacement),
      changesDispositifStore: changesPatrimoineStore(initialStateDispositif),
      changesMaterielStore: changesPatrimoineStore(initialStateMateriel),
      changesFaceStore: changesPatrimoineStore(initialStateFace),
    };
  },
  components: {
    storeRechercheProvider,
    emplacement,
    dispositif,
    materiel,
    face,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    tabs() {
      const tabs = [
        this.constantes.EMPLACEMENT,
        this.constantes.DISPOSITIF,
        this.constantes.MATERIEL,
        this.constantes.FACE,
      ];
      if (this.typePatrimoine === this.constantes.FACE) {
        return tabs;
      }
      const index = tabs.findIndex(e => e === this.typePatrimoine);
      return tabs.slice(0, index + 1);
    },
    getNumberOfEmplacementsSelected() {
      return this.selection.emplacements.length;
    },
    getNumberOfDispositifsSelected() {
      return this.selection.dispositifs.length;
    },
    getNumberOfMaterielsSelected() {
      return this.selection.materiels.length;
    },
    getNumberOfFacesSelected() {
      return this.selection.faces.length;
    },
  },
  methods: {
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    isVisible(tab) {
      return this.typePatrimoine === tab;
    },
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
    },
    setUpSelection(activeTab) {
      switch (activeTab) {
        case this.constantes.DISPOSITIF:
          this.selection.dispositifs = cloneDeep(this.patrimoineAssociated);
          this.selection.dispositifs
            .forEach(dispositif => this.addEmplacement(dispositif.emplacement));
          break;
        case this.constantes.MATERIEL:
          this.selection.materiels = cloneDeep(this.patrimoineAssociated);
          this.selection.materiels.forEach(materiel => this.addDispositif(materiel.dispositif));
          break;
        case this.constantes.FACE:
          this.selection.faces = cloneDeep(this.patrimoineAssociated);
          this.selection.faces.forEach(face => this.addMateriel(face.materiel));
          break;
        default:
          break;
      }
    },
    async addSelection(key, value) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const dataBody = this.getDataBody();
        const patrimoineSelectedIds = value.map(patrimoine => patrimoine.id);
        let patrimoine = null;
        switch (key) {
          case this.constantes.EMPLACEMENT:
            switch (this.typePatrimoine) {
              case this.constantes.DISPOSITIF:
                dataBody.query.emplacementIds = patrimoineSelectedIds;
                patrimoine = (await getAllDispositifs(dataBody)).data.result.items;
                patrimoine.forEach(p => this.addDispositif(p));
                break;
              case this.constantes.MATERIEL:
                dataBody.query.emplacementsId = patrimoineSelectedIds;
                patrimoine = (await getAllMateriels(dataBody)).data.result.items;
                patrimoine.forEach(p => this.addMateriel(p));
                break;
              case this.constantes.FACE:
                dataBody.query.emplacementIds = patrimoineSelectedIds;
                dataBody.query.nonCommercialisable = null;
                patrimoine = (await getAllFaces(dataBody)).data.result.items;
                patrimoine.forEach(p => this.addFace(p));
                break;
              default:
                value.forEach(val => this.addEmplacement(val));
                break;
            }
            break;
          case this.constantes.DISPOSITIF:
            switch (this.typePatrimoine) {
              case this.constantes.MATERIEL:
                dataBody.query.dispositifsId = patrimoineSelectedIds;
                patrimoine = (await getAllMateriels(dataBody)).data.result.items;
                patrimoine.forEach(p => this.addMateriel(p));
                break;
              case this.constantes.FACE:
                dataBody.query.dispositifIds = patrimoineSelectedIds;
                dataBody.query.nonCommercialisable = null;
                patrimoine = (await getAllFaces(dataBody)).data.result.items;
                patrimoine.forEach(p => this.addFace(p));
                break;
              default:
                value.forEach(val => this.addDispositif(val));
                break;
            }
            break;
          case this.constantes.MATERIEL:
            if (this.typePatrimoine === this.constantes.FACE) {
              dataBody.query.materielIds = patrimoineSelectedIds;
              dataBody.query.nonCommercialisable = null;
              patrimoine = (await getAllFaces(dataBody)).data.result.items;
              patrimoine.forEach(p => this.addFace(p));
            } else value.forEach(val => this.addMateriel(val));
            break;
          case this.constantes.FACE:
            value.forEach(val => this.addFace(val));
            break;
          default:
            break;
        }
        if (patrimoine?.length === 0) this.showSelectionToast();
        if (this.typePatrimoine !== key) {
          if (patrimoineSelectedIds.length > 1) {
            this.showSelectionToast(true);
          }
        }
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    removeSelection(key, value) {
      switch (key) {
        case this.constantes.EMPLACEMENT:
          this.selection.faces = this.selection.faces
            .filter(s => !value.map(v => v.id).includes(s.materiel.dispositif.emplacement.id));
          this.selection.materiels = this.selection.materiels
            .filter(s => !value.map(v => v.id).includes(s.dispositif.emplacement.id));
          this.selection.dispositifs = this.selection.dispositifs
            .filter(s => !value.map(v => v.id).includes(s.emplacement.id));
          value.forEach(val => this.removeEmplacement(val));
          break;
        case this.constantes.DISPOSITIF:
          this.selection.faces = this.selection.faces
            .filter(s => !value.map(v => v.id).includes(s.materiel.dispositif.id));
          this.selection.materiels = this.selection.materiels
            .filter(s => !value.map(v => v.id).includes(s.dispositif.id));
          value.forEach(val => this.removeDispositif(val));
          break;
        case this.constantes.MATERIEL:
          this.selection.faces = this.selection.faces
            .filter(s => !value.map(v => v.id).includes(s.materiel.id));
          value.forEach(val => this.removeMateriel(val));
          break;
        case this.constantes.FACE:
          value.forEach(val => this.removeFace(val));
          break;
        default:
          break;
      }
    },
    addEmplacement(emplacement) {
      if (!this.selection.emplacements.some(e => e.id === emplacement.id)) {
        this.selection.emplacements.push(emplacement);
      }
    },
    addDispositif(dispositif) {
      if (!this.selection.dispositifs.some(d => d.id === dispositif.id)) {
        this.selection.dispositifs.push(dispositif);
      }
      this.addEmplacement(dispositif.emplacement);
    },
    addMateriel(materiel) {
      if (!this.selection.materiels.some(m => m.id === materiel.id)) {
        this.selection.materiels.push(materiel);
      }
      this.addDispositif(materiel.dispositif);
    },
    addFace(face) {
      if (!this.selection.faces.some(f => f.id === face.id)) {
        this.selection.faces.push(face);
      }
      this.addMateriel(face.materiel);
    },
    removeEmplacement(emplacement) {
      this.selection.emplacements = this.selection.emplacements
        .filter(e => e.id !== emplacement.id);
    },
    removeDispositif(dispositif) {
      const nbrOfOccurences = (this.selection.dispositifs
        .filter(d => d.emplacement.id === dispositif.emplacement.id)).length;
      if (nbrOfOccurences === 1) {
        this.removeEmplacement(dispositif.emplacement);
      }
      this.selection.dispositifs = this.selection.dispositifs
        .filter(d => d.id !== dispositif.id);
    },
    removeMateriel(materiel) {
      const nbrOfOccurences = (this.selection.materiels
        .filter(m => m.dispositif.id === materiel.dispositif.id)).length;
      if (nbrOfOccurences === 1) {
        this.removeDispositif(materiel.dispositif);
      }
      this.selection.materiels = this.selection.materiels
        .filter(m => m.id !== materiel.id);
    },
    removeFace(face) {
      const nbrOfOccurences = (this.selection.faces
        .filter(f => f.materiel.id === face.materiel.id)).length;
      if (nbrOfOccurences === 1) {
        this.removeMateriel(face.materiel);
      }
      this.selection.faces = this.selection.faces
        .filter(f => f.id !== face.id);
    },
    getDataBody() {
      return {
        query: {
          societeId: this.societeActiveId,
        },
        limit: this.constantes.NO_PAGINATION,
      };
    },
    showSelectionToast(isMultipleSelection = false) {
      const params = {
        message: this.$t('patrimoine.warning.simpleSelection.' + this.typePatrimoine),
        type: 'is-warning',
        duration: 3500,
      };
      if (isMultipleSelection) {
        params.message = this.$t('patrimoine.warning.multipleSelection.' + this.typePatrimoine);
      }
      this.$buefy.toast.open(params);
    },
    loadDispositifsSelection() {
      return this.selection.dispositifs;
    },
    loadMaterielsSelection() {
      return this.selection.materiels;
    },
    loadFacesSelection() {
      return this.selection.faces;
    },
  },
  beforeDestroy() {
    Object.values(this.constantes.storeName).forEach(val => {
      if (this.$store.hasModule(val)) {
        this.$store.unregisterModule(val);
      }
    });
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setUpSelection(this.typePatrimoine);
      this.updateActiveTab(this.typePatrimoine);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
